import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { State } from "@shared/types/graphqlGenerated";

const StatesInfo_Shared_Query = gql`
  query StatesInfo_Shared_Query {
    viewer {
      states {
        id
        name
        abbr
      }
    }
  }
`;

interface StatesData {
  viewer: {
    states: State[];
  };
}

const useStatesInfoQuery = (options?: QueryHookOptions<StatesData>) => {
  return useQuery<StatesData>(StatesInfo_Shared_Query, options);
};

export type { StatesData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { StatesInfo_Shared_Query, useStatesInfoQuery };
